import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const Projects = () => {
  const projects = [
    {
      title: "Gaming Store",
      description: "En visningssida för en gaming butik med produktkatalog och användargränssnitt. Användare kan bläddra mellan produkter och sidor, men funktionalitet för köp och betalning är inte implementerad.",
      technologies: ["HTML, CSS, JavaScript"],
      status: "Komplett",
      images: [
        "/images/Xgaming.png",
        "/images/Xgaming2.png", 
        "/images/Xgaming3.png"
      ]
    },
    {
      title: "Restaurant Order System", 
      description: "En visningssida för beställningssystem för restauranger där kunder kan bläddra i menyn, lägga beställningar och betala direkt. Administratörer kan hantera menyer och orders.",
      technologies: ["HTML, CSS, JavaScript"],
      status: "Komplett",
      images: [
        "/images/res.png",
       
      ]
    },
    {
      title: "Portfolio Website",
      description: "Min egen portfolio byggd med React. Inkluderar projektvisning, kontaktformulär och professionell design för att visa upp tekniska färdigheter.",
      technologies: ["React"],
      status: "Komplett",
      images: [
        "/images/CV.png",
       
      ]
    }
  ];

  return (
    <section id="projects" className="section section-dark">
      <div className="container">
        <h2>Projekt</h2>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{ 
                  clickable: true,
                  dynamicBullets: true 
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                loop={true}
                spaceBetween={0}
                slidesPerView={1}
                className="project-swiper"
              >
                {project.images.map((img, i) => (
                  <SwiperSlide key={i}>
                    <img 
                      src={img} 
                      alt={`${project.title} screenshot ${i + 1}`} 
                      className="project-image" 
                      loading="lazy"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <div className="project-tech">
                  {project.technologies.map((tech, i) => (
                    <span key={i}>{tech}</span>
                  ))}
                </div>

                <div className="project-footer">
                  <span className="status komplett">
                    {project.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;